<template>
  <div class="contentBox">
    <div class="container">
      <!---->
      <div class="article">
        <div class="text page-title">Yêu cầu hủy tài khoản game</div>
        <p class="strong">Đăng nhập tài khoản nền tảng đã liên kết với game</p>
        <div class="text">
          Người chơi thân mến, để đảm bảo an toàn cho tài khoản của bạn, vui
          lòng đăng nhập vào bất kỳ tài khoản nền tảng nào đã liên kết với tài
          khoản game mà bạn muốn hủy.
        </div>
        <div class="login-type-btn" @click="handleClick('account')">
          <img
            src="../../assets/img/deleteAccount/account_icon.png"
            alt=""
            class="type-icon"
          /><span class="type-title">Account</span>
        </div>
        <div class="login-type-btn" @click="handleClick('fb')">
          <img
            src="../../assets/img/deleteAccount/fb_icon.png"
            alt=""
            class="type-icon"
          /><span class="type-title">Facebook</span>
        </div>
        <div class="login-type-btn">
          <div id="g_id_signin2"></div>
          <img
            src="../../assets/img/deleteAccount/google_icon.png"
            alt=""
            class="type-icon"
          /><span class="type-title">Google Play</span>
        </div>
        <div class="login-type-btn" @click="handleClick('guest')">
          <img
            src="../../assets/img/deleteAccount/guest_icon.png"
            alt=""
            class="type-icon"
          /><span class="type-title">Guest Account</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      fb_appid: "",
      client_id: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v3.3";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
    this.getData();
  },
  mounted() {},
  methods: {
    getData() {
      let game_id = this.$route.query.g;
      let params = {
        g: game_id,
      };
      this.$http.get("/login/index", { params }).then((res) => {
        if (res.data.code == 200) {
          this.fb_appid = res.data.data.fb_appid;
          if (res.data.data.client_id) {
            this.client_id = res.data.data.client_id;
            this.init();
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleClick(name) {
      let game_id = this.$route.query.g;
      switch (name) {
        case "account":
          this.$router.push({
            path: "/main/deletion/login",
            query: {
              g: game_id,
            },
          });
          break;
        case "fb":
          this.loginWithFacebook();
          break;
        case "google":
          // this.loginWithGoogle();
          break;
        case "guest":
          this.$router.push("/main/deletion/tip");
          break;

        default:
          break;
      }
    },
    loginWithFacebook() {
      FB.init({
        appId: this.fb_appid,
        cookie: true,
        xfbml: true,
        version: "v11.0",
      });
      FB.login((response) => {
        let res = JSON.parse(JSON.stringify(response));
        if (res.authResponse?.accessToken) {
          this.Login(1, res.authResponse.accessToken);
        } else {
          this.$message.error(res.status);
        }
      });
    },

    Login(num, access_token) {
      let game_id = this.$route.query.g;
      let params = {
        game_id,
        access_token: access_token,
      };
      let url = num == 1 ? "/login/fbLogin" : "/login/googleLogin";
      this.$http.post(url, params).then((res) => {
        if (res.data.code === 200) {
          this.handleCheck(res.data.data.token);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    //谷歌登录
    init() {
      this.gload();
    },
    gload() {
      if (window.google && window.google.accounts) {
        window.google.accounts.id.initialize({
          // 主要就是填写client_id
          client_id: this.client_id,
          callback: this.handleCredentialResponse,
        });
        console.log("Google API initialized");
        window.google.accounts.id.renderButton(
          document.getElementById("g_id_signin2"),
          {
            type: "standard",
            theme: "filled_blue",
            size: "large",
            text: "continue_with",
            shape: "pill",
            logo_alignment: "left",
            width: 300,
          }
        );
      } else {
        console.error("Google API not loaded");
      }
    },
    decodeJwtResponse(token) {
      const strings = token.split(".");
      return JSON.parse(
        decodeURIComponent(
          escape(window.atob(strings[1].replace(/-/g, "+").replace(/_/g, "/")))
        )
      );
    },

    handleCredentialResponse(response) {
      if (response) {
        this.Login(2, response.credential);
      }
    },
    handleCheck(token) {
      this.$router.push({
        path: "/main/deletion/isDeleteAccount",
        query: {
          t: token,
        },
      });
    },
  },
};
</script>

<style>
@import "./css/index.css";
.S9gUrf-YoZ4jf {
  opacity: 0;
}
#g_id_signin2 {
  position: absolute;
  width: auto;
}
</style>
